import { render } from "./ReportHeader.vue?vue&type=template&id=30aa7253&scoped=true"
import script from "./ReportHeader.vue?vue&type=script&lang=js"
export * from "./ReportHeader.vue?vue&type=script&lang=js"

import "./ReportHeader.vue?vue&type=style&index=0&id=30aa7253&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30aa7253"],['__file',"src/components/reports/toxicology/ReportHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30aa7253"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30aa7253', __exports__)) {
    console.log('reload')
    api.reload('30aa7253', __exports__)
  }
  
  module.hot.accept("./ReportHeader.vue?vue&type=template&id=30aa7253&scoped=true", () => {
    console.log('re-render')
    api.rerender('30aa7253', render)
  })

}


export default __exports__